import { useMemo } from 'react';
import { useAuth } from '../../../../../../context/AuthContext';

export const useFilteredLead = (leadList, leadStatusMaster = []) => {
  const { authUser } = useAuth();

  const filteredData = useMemo(() => {
    const defaultData = { 
      mine: [], 
      myAssigned: [], 
      highPriority: [], 
      medPriority: [], 
      lowPriority: [],
      byStatus: [] 
    };

    if (!leadList || !Array.isArray(leadList)) {
      // Pre-populate empty arrays for the statuses even if leadList is empty
      return {
        ...defaultData,
        byStatus: leadStatusMaster.map(status => ({ ...status, leads: [] }))
      };
    }

    // 1. Standard Filters
    const mine = leadList.filter(lead => lead.userId === authUser?.id);
    const myAssigned = leadList.filter(lead => lead.assignedTo === authUser?.id);
    const highPriority = leadList.filter(lead => lead.priority === 1);
    const medPriority = leadList.filter(lead => lead.priority === 2);
    const lowPriority = leadList.filter(lead => lead.priority === 3);

    // 2. Map master data to include matched leads
    const byStatus = leadStatusMaster.map(statusItem => {
      return {
        value: statusItem.value,
        label: statusItem.label,
        // Filter leads belonging specifically to this status value
        leads: leadList.filter(lead => lead.status === statusItem.value)
      };
    });

    return {
      mine,
      myAssigned,
      highPriority,
      medPriority,
      lowPriority,
      byStatus
    };

  }, [leadList, authUser?.id, leadStatusMaster]); 

  return filteredData;
};